<template>
	<section class="container" ref="container">

		<article class="container__body container__body--lg">

			<stepper></stepper>

			<transition name="fade" mode="out-in">
				<router-view dusk="currentView"></router-view>
			</transition>
		</article>

	</section>
</template>

<script>
	import Stepper from './stepper.vue';
	import {mapGetters} from 'vuex';
    export default {
        name: "orderManager",
		components:{
            Stepper
		},
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(!vm.$store.getters.selectionsValid || !vm.$store.getters.completedProduct){
                    vm.$router.replace({name:'product'});
                }
            })
        },
        beforeRouteUpdate(to, from, next){
            if(this.$refs.container){
                this.$refs.container.scrollTo(0,0);
            }
            next();
        },

    }
</script>

<style scoped>

</style>
